import { ExternalLink, MapPin, Trash2 } from "lucide-react";
import { fmtDate } from "@/lib/format";
import { L } from "@/i18n";

const STATUS = {
  expired: ["Expired", "text-slate-400 border-slate-600/50 bg-slate-500/10"],
  upcoming: ["Scheduled", "text-amber-400 border-amber-500/30 bg-amber-500/10"],
  scheduled: ["Scheduled", "text-amber-400 border-amber-500/30 bg-amber-500/10"],
  today: ["Today", "text-emerald-400 border-emerald-500/30 bg-emerald-500/10"],
};

const STATUS_PT = { Expired: "Expirado", Scheduled: "Agendado", Today: "Hoje" };

const ExamStatus = ({ exam }) => {
  const key = exam.status ?? (exam.days_remaining < 0 ? "expired" : "upcoming");
  const [label, cls] = STATUS[key] ?? [key, STATUS.expired[1]];
  return <span className={`rounded-md border px-2 py-0.5 font-mono text-[11px] ${cls}`}>{L(label, STATUS_PT[label])}</span>;
};

const days = (d) => (d == null ? "" : d < 0 ? L("{n} days ago", "há {n} dias", { n: -d }) : d === 0 ? L("today", "hoje") : L("in {n} days", "em {n} dias", { n: d }));

export const ExamList = ({ exams, onRemove }) => (
  <ul className="space-y-2">
    {[...exams].sort((a, b) => (a.exam_date < b.exam_date ? 1 : -1)).map((e) => (
      <li key={e.id} className="flex items-start gap-3 rounded-md bg-[#0f172a] p-3" data-testid={`student-exam-item-${e.id}`}>
        <span className="shrink-0 rounded bg-amber-500/10 px-2 py-1 font-mono text-xs text-amber-400">{e.module}</span>
        <div className="min-w-0 flex-1 text-xs">
          <div className="flex items-center justify-between gap-2">
            <p className="text-slate-200 truncate">{e.module_name}</p>
            <div className="flex items-center gap-2">
              <ExamStatus exam={e} />
              <button
                type="button"
                onClick={() => onRemove(e)}
                className="p-1 rounded text-slate-500 hover:text-rose-400 hover:bg-rose-500/10 transition-colors"
                data-testid={`student-exam-remove-${e.id}`}
                aria-label={L("Remove exam", "Remover exame")}
              >
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
          </div>
          <p className="mt-1 text-slate-500">
            {fmtDate(e.exam_date)} {e.exam_time} · {days(e.days_remaining)}
          </p>
          {e.location && (
            <p className="mt-0.5 flex items-center gap-1 text-slate-500">
              <MapPin className="h-3 w-3" /> {e.location}
              {e.location_link && (
                <a href={e.location_link} target="_blank" rel="noreferrer" className="ml-1 text-amber-400 hover:text-amber-300" data-testid={`student-exam-map-${e.id}`}>
                  <ExternalLink className="h-3 w-3" />
                </a>
              )}
            </p>
          )}
          {e.notes && <p className="mt-1 text-slate-400">{e.notes}</p>}
        </div>
      </li>
    ))}
  </ul>
);
